import { z } from "zod/v4";

import {
  EmailTypeKey,
  EmailTypeValue,
  PhoneNumberPreferences,
} from "@/enums/preferences";

import type { PhoneSelectionType } from "@/enums/communicationLogs";
import type { CommunicationProvider } from "@/enums/communicationProviders";
import type { AudioDevicePreferences } from "@/enums/preferences";
import type { AudioDeviceResponseSchema } from "@/schemas/communication";

export interface UpdateEmailTypePayload {
  key: EmailTypeKey;
  value: EmailTypeValue[];
}

export interface PhoneNumberRoutingValue {
  type: PhoneSelectionType;
  phone_number?: string;
}

export interface UpdatePhoneNumberRoutingPayload {
  key: PhoneNumberPreferences;
  value: PhoneNumberRoutingValue | CommunicationProvider;
}

export const EmailTypeResponseSchema = z.object({
  created_at: z.string(),
  id: z.number(),
  key: z.enum(EmailTypeKey),
  updated_at: z.string(),
  value: z.array(z.enum(EmailTypeValue)),
});

export const PhoneNumberResponseSchema = z.object({
  created_at: z.string(),
  id: z.number(),
  key: z.literal(PhoneNumberPreferences.routing),
  updated_at: z.string(),
  value: z.object({
    type: z.string(),
    phone_number: z.string().optional(),
  }),
});

export const PhoneProviderResponseSchema = z.object({
  created_at: z.string(),
  id: z.number(),
  key: z.literal(PhoneNumberPreferences.provider),
  updated_at: z.string(),
  value: z.string(),
});

export interface EmailType {
  name: string;
  id: EmailTypeValue;
}

export interface DraggableEvent {
  moved?: {
    element: EmailType;
    newIndex: number;
    oldIndex: number;
  };
}

export type EmailTypeResponse = z.infer<typeof EmailTypeResponseSchema>;

export type PhoneNumberResponse = z.infer<typeof PhoneNumberResponseSchema>;

export type PhoneProviderResponse = z.infer<typeof PhoneProviderResponseSchema>;

export interface AudioDeviceValue {
  device_id: string;
  label: string;
}

export interface UpdateAudioDevicePayload {
  key: AudioDevicePreferences;
  value: AudioDeviceValue;
}

export type AudioDeviceResponse = z.infer<typeof AudioDeviceResponseSchema>;
